import React from "react";
import BlogPostRow from "./BlogPostRow";

/**
 * Brand-new AI drafts awaiting approval — posts with no published counterpart.
 * Content refreshes are listed separately by RefreshPostsSection.
 */
const PendingPostsSection = ({ posts, onCreate, onWrite, onOpen }) => (
  <>
    <div className="flex items-center justify-between mb-5">
      <div>
        <h2 className="text-xl font-bold text-gray-800">New Posts — Pending Approval</h2>
        <p className="text-sm text-gray-500 mt-0.5">
          Brand-new drafts, generated twice a week (Tue &amp; Fri at 9am PT). Click a post to review.
        </p>
      </div>
      <div className="flex items-center gap-3">
        <button
          onClick={onWrite}
          className="px-4 py-2 bg-blue-600 text-white text-sm font-medium rounded-lg hover:bg-blue-700 transition-colors"
        >
          ✏️ Write in Sanity ↗
        </button>
        <button
          onClick={onCreate}
          className="px-4 py-2 bg-purple-600 text-white text-sm font-medium rounded-lg hover:bg-purple-700 transition-colors"
        >
          ✍️ Create Now
        </button>
        <span className={`px-3 py-1 rounded-full text-sm font-medium ${
          posts.length > 0 ? "bg-amber-100 text-amber-800" : "bg-green-100 text-green-800"
        }`}>
          {posts.length === 0 ? "✓ All clear" : `${posts.length} pending`}
        </span>
      </div>
    </div>

    {posts.length === 0 ? (
      <div className="text-center py-12 bg-white rounded-lg shadow-sm border border-gray-200 mb-10">
        <div className="text-5xl mb-4">📭</div>
        <p className="text-gray-500 text-lg">No new posts pending review.</p>
        <p className="text-gray-400 text-sm mt-1">New posts are generated every Tuesday and Friday at 9am PT.</p>
      </div>
    ) : (
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 divide-y divide-gray-100 mb-10">
        {posts.map(post => (
          <BlogPostRow
            key={post.id}
            post={post}
            onClick={() => onOpen(post.id)}
            meta={
              <p className="text-xs text-gray-400 mt-0.5">
                {post.date} · {post.readTime}
                {post.status === "regenerating" && (
                  <span className="ml-2 text-yellow-600 font-medium">⏳ Regenerating…</span>
                )}
              </p>
            }
          />
        ))}
      </div>
    )}
  </>
);

export default PendingPostsSection;
